import axios from "axios";
import atributes from "../../models/gestionEmpleados/empleados/atributes";
import attributes from "../../models/atributos/attributes";
import { getConfig } from "@/config";

class service {
  constructor() {
    this._config = null;
  }

  get config() {
    if (!this._config) {
      const cfg = getConfig();
      if (!cfg) throw new Error("Config not loaded");
      this._config = cfg;
    }
    return this._config;
  }

  getAtributes() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    const empId = localStorage.getItem("empId");
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/empatrib/${empId}`, { headers })
      .then(({ data }) => {
        return data.map((item) => {
          return atributes.fromJson(item);
        });
      });
  }
  getAllAtributes() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios.get(`${url}/atributos/all`, { headers }).then(({ data }) => {
      return data.map((item) => {
        return attributes.fromJson(item);
      });
    });
  }
  // getAllAtributes() {
  //   let token = localStorage.getItem("token");
  //   const url = this.config.apiUrl;
  //   const operid = localStorage.getItem("operId");
  //   let headers = {
  //     Authorization: `Bearer ${token}`,
  //   };
  //   const fecha = moment().format("YYYY-MM-DD") + "T00:00:00.000Z";

  //   return axios
  //     .get(`${url}/atributos/${operid}&${fecha}`, { headers })
  //     .then(({ data }) => {
  //       return data.map((item) => {
  //         return atributes.fromJson(item);
  //       });
  //     });
  // }
  new(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    const operid = localStorage.getItem("operId");
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    let payload = {
      atribId: data.atribId,
      // atribNombre: data.atribNombre,
      empId: parseInt(localStorage.getItem("empId"), 10),
      valor: data.valor,
    };
    return axios.post(`${url}/empatrib`, payload, { headers });
  }
  delete = (data) => {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const empId = localStorage.getItem("empId");
    let atribid = data.id;

    return axios.delete(`${url}/empatrib/${empId}&${atribid}`, {
      headers,
    });
  };

  edit(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    const empId = localStorage.getItem("empId");
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    let atribid = data.nameId;

    let payload = {
      atribNombre: data.name,
      valor: data.value,
    };

    return axios
      .patch(`${url}/empatrib/${empId}&${atribid}`, payload, { headers })
      .then(() => {});
  }
  addEmployed(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };

    let payload = {
      legajo: data.file,
      tdoc: data.typeDoc,
      ndoc: data.doc,
      apellido: data.lastName,
      nombres: data.name,
      fecAlta: data.high + "T00:00:00.000Z",
      fecBaja: data.down,
      grupoId: data.group,
      horarioId: data.schedule,
      liqModeloId: data.model,
      tarjetaId: data.card,
    };
    return axios.post(`${url}/empleados`, payload, { headers });
  }
}
export default service;
